import { ErrorCode } from '@ps/web-core-enums';
import type { MonoTypeOperatorFunction } from 'rxjs';
import { timer } from 'rxjs';
import { delayWhen, retryWhen, scan, tap } from 'rxjs/operators';

import { RequestError } from '../errors/RequestError';
import type { Retry } from '../types/Request';

export function handleError<T>({
  retry,
  service,
  method,
  requestId
}: {
  retry: Retry;
  service: string;
  method: string;
  requestId?: string;
}): MonoTypeOperatorFunction<T> {
  const delay: Retry['delay'] =
    retry.delay ??
    function (retryCount) {
      return Math.pow(2, retryCount) * 1000;
    };

  return (input) =>
    input.pipe(
      retryWhen((errors) =>
        errors.pipe(
          scan((acc, error) => ({ count: acc.count + 1, error }), {
            count: 0,
            error: undefined as unknown as Error
          }),
          tap(({ count, error }) => {
            if (count > retry.count) {
              if (error.name === 'TimeoutError') {
                throw new RequestError({
                  service,
                  method,
                  body: {
                    code: ErrorCode.CLIENT_TIMEOUT,
                    text: 'Request timed out'
                  },
                  requestId
                });
              }
              throw error;
            }
          }),
          delayWhen((current: { count: number }) => timer(delay(current.count)))
        )
      )
    );
}
